import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spin from 'antd/lib/spin';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { accountRoles } from '../../../common/enums';
import { AccountDetail } from '../components';
import accountApi, { apiCallIds } from '../api';
import {
  acceptAccountDocumentsActions,
  rejectAccountDocumentsActions,
  selectDetailEditable,
  setDetailEditableAction,
  updateAccountActions,
  fetchAccountUpdateLogsActions,
  selectAccountUpdateLogs,
} from '../ducks';
import { selectIsAdmin } from '../../auth/ducks';

const mapStateToProps = state => ({
  isAdmin: selectIsAdmin(state),
  detailEditable: selectDetailEditable(state),
  isFetchingAccount: selectIsInProgress(state, apiCallIds.FETCH_ACCOUNT),
  isUpdating: selectIsInProgress(state, apiCallIds.UPDATE_ACCOUNT),
  accountUpdateLogs: selectAccountUpdateLogs(state)

});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      acceptAccountDocuments: acceptAccountDocumentsActions.request,
      rejectAccountDocuments: rejectAccountDocumentsActions.request,
      setDetailEditable: setDetailEditableAction,
      updateAccount: updateAccountActions.request,
      fetchAccountUpdateLogs: fetchAccountUpdateLogsActions.request
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class AccountDetailContainer extends Component {
  static propTypes = {
    account: PropTypes.object,
    accountId: PropTypes.string,
    actions: PropTypes.object.isRequired,
    detailEditable: PropTypes.string.isRequired,
    isFetchingAccount: PropTypes.bool.isRequired,
    isUpdating: PropTypes.bool.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    accountUpdateLogs: PropTypes.object
  };

  state = { sameInstallAccounts: [], devices: [], devicesLoading: false, devicesError: false };

  componentDidMount() {
    this.getSameInstallAccounts();
    this.getDevices();
  }

  componentDidUpdate(prevProps) {
    const { account } = this.props;
    if (prevProps.account !== account) {
      this.getAccountUpdateLogs()
    }
    if (prevProps.accountId !== this.props.accountId || prevProps.isAdmin !== this.props.isAdmin) {
      this.sameInstallGeneration += 1;
      this.devicesGeneration += 1;
      this.setState({ sameInstallAccounts: [], devices: [], devicesLoading: false, devicesError: false });
      this.getSameInstallAccounts();
      this.getDevices();
    }
  }

  componentWillUnmount() {
    this.sameInstallGeneration += 1;
    this.devicesGeneration += 1;
    this.props.actions.setDetailEditable('');
  }

  sameInstallGeneration = 0;

  devicesGeneration = 0;

  getSameInstallAccounts = () => {
    const { accountId, isAdmin } = this.props;
    if (!isAdmin || !accountId) return;
    const generation = ++this.sameInstallGeneration;
    const isCurrent = () => generation === this.sameInstallGeneration && this.props.isAdmin;
    accountApi.fetchSameInstallAccounts(accountId).then(response => {
      if (isCurrent()) {
        this.setState({ sameInstallAccounts: response.ok && Array.isArray(response.data) ? response.data : [] });
      }
    }).catch(() => {
      if (isCurrent()) this.setState({ sameInstallAccounts: [] });
    });
  };

  getDevices = () => {
    const { accountId, isAdmin } = this.props;
    if (!isAdmin || !accountId) return;
    this.setState({ devicesLoading: true, devicesError: false });
    const generation = ++this.devicesGeneration;
    const isCurrent = () => generation === this.devicesGeneration && this.props.isAdmin;
    accountApi.fetchAccountDevices(accountId).then(response => {
      if (!isCurrent()) return;
      const ok = response.ok && Array.isArray(response.data);
      this.setState({ devices: ok ? response.data : [], devicesLoading: false, devicesError: !ok });
    }).catch(() => {
      if (isCurrent()) this.setState({ devices: [], devicesLoading: false, devicesError: true });
    });
  };

  onSubmit = accountData => {
    const { actions, accountId } = this.props;
    actions.updateAccount({ accountId, accountData });
  };

  onEdit = accountId => {
    this.props.actions.setDetailEditable(accountId);
  };

  onAcceptDocuments = () => {
    const { actions, accountId } = this.props;
    actions.acceptAccountDocuments({ accountId });
  };

  onRejectDocuments = rejectReason => {
    const { actions, accountId } = this.props;
    actions.rejectAccountDocuments({ accountId, rejectReason });
  };

  getAccountUpdateLogs = () => {
    const { actions, accountId } = this.props;
    actions.fetchAccountUpdateLogs({ accountId });
  }

  render() {
    const { account, isAdmin, detailEditable, isFetchingAccount, isUpdating, accountUpdateLogs } = this.props;

    if (!account) {
      return (
        <Spin spinning={isFetchingAccount}>
          <div className="spin-empty-content" />
        </Spin>
      );
    }

    const isDebtor = account.role === accountRoles.DEBTOR;

    const isEditable = detailEditable === account.id;

    return (
      <Spin spinning={isFetchingAccount}>
        <AccountDetail
          account={account}
          isEditable={isEditable}
          isUpdating={isUpdating}
          onAcceptDocuments={this.onAcceptDocuments}
          onEdit={this.onEdit}
          onRejectDocuments={this.onRejectDocuments}
          onSubmit={this.onSubmit}
          isDebtor={isDebtor}
          isAdmin={isAdmin}
          accountUpdateLogs={accountUpdateLogs}
          sameInstallAccounts={this.state.sameInstallAccounts}
          devices={this.state.devices}
          devicesLoading={this.state.devicesLoading}
          devicesError={this.state.devicesError}
          onRetryDevices={this.getDevices}
        />
      </Spin>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/account-management/containers/AccountDetailContainer.js